import React from "react";
import styles from "./emptyDataView.module.css";
import IMAGES from "../../assets/images/images";

const EmptyDataView  = ({ message = "No data", icon = IMAGES.nodata }) => {
    return (
        <div className={styles.emptyContainer}>
            <img src={icon} alt="No data" className={styles.icon} />
            <div className={styles.message}>{message}</div>
        </div>
    );
};

export default EmptyDataView ;
